<template>
  <div>
    <div
      class="comment-section list-unstyled p-2">
      <CommentItem
        v-for="comment in comments"
        :id="comment.id"
        :key="comment.id"
        :comment="comment"
        :login-user-id="user.id"
        @delete="deleteComment" />
      <CommentInput
        :id="userId"
        ref="pathActivityCommentInput"
        field-id="user"
        @submit="addComment" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CommentInput from '@/components/view/CommentInput.vue'
import CommentItem from '@/components/view/CommentItem.vue'
export default {
  components: {
    CommentInput,
    CommentItem
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    comments: {
      type: Array,
      required: true
    },
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isManager']),
  },
  methods: {
    addComment(formData) {
      if (this.isManager) {
        if (!window.confirm('これはメンバーに送るコメントです。メンバー本人と指導者が見れます。よろしいですか？')) return
      }
      this.$store.commit('startLoading')
      return this.$axios.post('/profiles/path-activity-comments/', formData).then(() => {
        this.$emit('refetch')
        this.$refs.pathActivityCommentInput.reset()
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    deleteComment(commentId) {
      if (!window.confirm('コメントを削除してもよろしいですか?')) return
      this.$store.commit('startLoading')
      return this.$axios.delete(`/profiles/path-activity-comments/${commentId}/`).then(() => {
        this.$emit('refetch')
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.comment-section {
  background-color: $grey15;
}

</style>